// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2V1D8","icon":"SortAdornment_icon__3HkvD","up":"SortAdornment_up__1hf_j","down":"SortAdornment_down__1I4et","active":"SortAdornment_active__1TwBP"};